import Tabs from './Tabs'
import ModalTabs from './modal-tabs'

export default Tabs
export { ModalTabs }
